// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles__empty___uc-il","emptyTitle":"styles__emptyTitle___VXQt-"};